export default __webpack_public_path__ + "static/media/time-icon.7ab81ad5.svg";